import { createAction } from '../../../../store.model';
import { ActionType } from '../teamschat-summary.action';

import { ChatSummary } from './../model/chat-summary.model';

export interface ToggleCategory {
    category: ChatSummary;
    isOpen: boolean;
}

export const toggleCategory = createAction<ActionType, ToggleCategory>(
    ActionType.TEAMS_CALL__TCS__TOGGLE_CATEGORY,
);
